import React from 'react'
import { useState, useEffect } from 'react';
import Selector from './Selector';
import SnapsWise from './SnapsWise';

const Audiobook = ({subject, exerciseHandler}) => {
    console.log(subject, "exercise")
    const [transcripts, setTranscripts] = useState([])
    const [tabs, setTabs]  = useState([]) 
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [currentScript, setCurrentScript] = useState(null)
    const [key, setKey] = useState(0);

    const getTranscripts = async (course) => {
        const token = localStorage.getItem("token");
        const outdata={"owner": course.owner, "author":course.author, 'title': course.title, 'language':course.language, "type": course.type}          
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/subjects/get-structure`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(outdata),
        });
        
        if (response.ok) {
            const json = await response.json();
            setTranscripts(json)
        };
    }

    useEffect(() => {
        if (transcripts && transcripts.length > 0) {
            setCurrentScript(transcripts[activeTabIndex])
            setKey(prev => prev + 1);
        }
    },[activeTabIndex, transcripts])
       
    useEffect(() => {
        if (subject){
            getTranscripts(subject)
        }
    },[subject]);

    useEffect(() => {
        if (transcripts && transcripts.length > 0) {
            const files = transcripts
                .filter(x => "file" in x)
                .map(x => x.file);
            setTabs(files);
        }
    },[transcripts])

    return tabs && tabs.length > 0 && currentScript ? (
        <div className='h-screen w-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30 overflow-hidden flex flex-col'>
            {/* Header - Glass morphism style */}
            <div className='bg-gradient-to-r from-blue-500/90 to-indigo-600/90 backdrop-blur-sm w-full flex-shrink-0 border-b border-white/20'>
                <div className='flex items-center justify-between p-4'>
                    <button 
                        className="flex-shrink-0 text-white hover:text-blue-100 transition-all duration-200 p-2 hover:bg-white/20 rounded-xl backdrop-blur-sm"
                        onClick={() => { exerciseHandler(null) }}      
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    
                    <div className='text-center flex-1 min-w-0 px-2'>
                        <h1 className='font-bold text-sm sm:text-xl md:text-2xl text-white truncate' title={subject.title}>
                            {subject.title}
                        </h1>
                        <p className='text-xs sm:text-sm text-blue-100/90 mt-1 truncate' title={`by ${subject.author}`}>
                            by {subject.author}
                        </p>
                    </div>
                    
                    <div className='flex-shrink-0 w-8 sm:w-10'></div>
                </div>

                {/* File Selector */}
                <div className="px-4 pb-4">
                    <Selector 
                        clickHandler={(tab_index) => {
                            setActiveTabIndex(tab_index);
                        }} 
                        tabsData={tabs} 
                        active={activeTabIndex}
                    />
                </div>
            </div>
            
            {/* Content Area */}
            <div className='flex-1 min-h-0'>
                <SnapsWise 
                    key={`${currentScript.file?.file}-${key}`} 
                    subject={subject} 
                    file={currentScript}
                />
            </div>
        </div>
    ) : (
        <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-white/40 shadow-lg">
                <div className="text-gray-600 text-lg">Loading your audiobook...</div>
            </div>
        </div>
    );
}

export default Audiobook;